module.exports = __webpack_public_path__ + "img/hino_thumbnail.4e9197b7.png";